import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useRagThresholds, getRagAccent } from '@/hooks/useRagThresholds';

interface MatchScoreBadgeProps {
  score: number;
}

export function MatchScoreBadge({ score }: MatchScoreBadgeProps) {
  const thresholds = useRagThresholds();
  const accent = getRagAccent(score, thresholds);
  return (
    <Badge variant={accent} accent={accent as any} className="text-xs font-semibold px-1.5 py-0 leading-5 tabular-nums">
      {score}%
    </Badge>
  );
}
